import styled from 'styled-components'

import theme from 'theme_'
import CommonButton from 'components/Button/CommonButton'
import { Regular } from 'components/Typography'

export const StyledLoginForm = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 347px;
  padding: 5px;
  margin: 0 auto;

  @media ${theme.devices.tablet} {
    max-width: 471px;
    padding: 0;
  }
`

export const StyledResendText = styled(Regular)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin 0 24px;
  margin-top: ${theme.spacing.md};
  text-align: center;
`
export const SubmitTwoFaWrapper = styled.div`
  margin: 0 auto;
  margin-top: 12px;
  width: 70%;
  display: inline-flex;
  justify-content: center;
  gap: 16px;
  & > * {
    flex: 1;
  }

  @media ${theme.devices.mobile} {
    width: inherit;
    margin: 0;
    padding: 0 24px;
    margin-top: 12px;
    flex-direction: column;
    & > * {
      width: 100%;
    }
  }
`
export const TwoFaInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 14px;
  margin-top: 40px;
  margin-bottom: 40px;

  @media ${theme.devices.mobile} {
    margin: 24px 24px;
    & > * {
      gap: 12px;
    }
  }
`

export const ResentWrapper = styled.div`
  margin: 0 auto;
  margin-top: 12px;
  width: 60%;
  display: flex;
  justify-content: center;
  gap: 16px;
  & > * {
    flex: 1;
  }

  @media ${theme.devices.mobile} {
    width: inherit;
    margin: 0 24px;
    margin-top: 12px;
    flex-direction: column;
    & > * {
      width: 100%;
    }
  }
`

export const StyledProceedButton = styled(CommonButton)`
  width: 160px;

  @media ${theme.devices.mobile} {
    width: 100%;
  }
`

export const StyledNumberField = styled.input`
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 8px;
  border: 1px solid;

  @media ${theme.devices.mobile} {
    width: 32px;
    height: 32px;
  }
`

export const StyledButton = styled.button`
  color: ${theme.colors.horizonOrange};
  text-decoration: none;
  margin-left: 4px;
  background: none !important;
  border: none;
  padding: 0 !important;
  cursor: pointer;
`
export const StyledEmail = styled.span`
  color: ${theme.colors.horizonOrange};
`
